import React from 'react';
import { Col, Row, Input, Slider, Button } from 'antd';
import ImageComponent from '@sharedComponent/image-component';
import { images } from '@assets/img';
import Cropper from 'react-easy-crop';
import Header from '@sharedComponent/header/header';

export const CoverPhotoPresentation = ({ state, cancel, upload, handleChange, fileChange, onCropComplete, setCrop, setZoom }) => {
	return (
		<>
			<Header title="Dashboard / Cover Photo" />

			<Row className="card_container">
				<Col className="" xl={24} lg={24} md={24} sm={24} xs={24}>
					{state.imageSrc ? (
						<Row>
							<Col className="crop_img_cover">
								<Cropper
									image={state.imageSrc}
									crop={state.crop}
									zoom={state.zoom}
									// cropSize={{ width: 500, height: 150 }}
									cropSize={{ width: 800, height: 150 }}
									aspect={3 / 2}
									onCropChange={setCrop}
									onCropComplete={onCropComplete}
									onZoomChange={setZoom}
								/>
							</Col>
						</Row>
					) : (
						<Col className="drop_zone_center">
							<Col className="drop_zone" xl={6} lg={6} md={6} sm={20} xs={22}>
								<ImageComponent className="drop_icon" src={images.upload} />
								<Col className="drop_name">
									<label htmlFor="coverphoto" style={{ cursor: 'pointer' }}>
										Browse Media{' '}
									</label>
								</Col>
								<Input
									type="file"
									id="coverphoto"
									accept="image/*"
									name="coverphoto"
									onChange={(e) => fileChange(e, 'coverphoto')}
									style={{ display: 'none' }}
								/>
							</Col>
						</Col>
					)}
				</Col>
				<Col className="" xl={24} lg={24} md={24} sm={24} xs={24}>
					<Row>
						<Col xl={12} lg={12} md={24} sm={24} xs={24}>
							<Row>
								<Col xl={4} lg={4} md={4} sm={4} xs={4} className="zoom_name">
									Zoom
								</Col>
								<Col xl={19} lg={19} md={19} sm={19} xs={19}>
									<Slider
										min={1}
										max={20}
										defaultValue={state.zoom}
										onAfterChange={(e) => {
											handleChange('zoom', e);
										}}
									/>
								</Col>
								<Col xl={1} lg={1} md={1} sm={1} xs={1}></Col>
							</Row>
						</Col>

						<Col xl={12} lg={12} md={24} sm={24} xs={24}>
							<Row>
								<Col xl={11} lg={11} md={24} sm={24} xs={24}>
									<Button className="cancel_btn" onClick={cancel}>
										Cancel
									</Button>
								</Col>
								<Col xl={2} lg={2} md={24} sm={24} xs={24} className="mt_5"></Col>
								<Col xl={11} lg={11} md={24} sm={24} xs={24} className="">
									<Button className="Upload_btn" onClick={upload}>
										Upload
									</Button>
								</Col>
							</Row>
						</Col>
					</Row>
				</Col>
			</Row>
		</>
	);
};
